import React from "react";
import { connect } from "react-redux";
import { Layout, Menu } from "antd";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
// import Hamburger from "components/common/Hamburger";
import MaterialIcon from "components/common/MaterialIcon";
import screenFull from "services/screen-full";
import { logout, changeCurrentPosition, changeCurrentRole, } from "routes/Auth/Module";
import Avatar from "components/common/Avatar";

@withRouter
@connect((state) => ({
  currentUser: state.Auth.currentUser,
  currentPosition: state.Auth.currentPosition,
  currentRole: state.Auth.currentRole,
}), {
    changeCurrentPosition,
    logout,
    changeCurrentRole: changeCurrentRole,
})
@autobind
/**
 *
 */
export default class Nav extends React.PureComponent {
  static propTypes = {
    currentUser: PropTypes.object,
    currentPosition: PropTypes.object,
    onHamburgerToggle: PropTypes.func,
    history: PropTypes.object,
    changeCurrentPosition: PropTypes.func,
    logout: PropTypes.func,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      isFullScreen: false,
    };

    screenFull.onChange(() => this.setState({ isFullScreen: screenFull.isFullScreen }));
  }

  /**
   *
   * @param {Object} item
   * @param {String} key
   * @param {Array} keyPath
   */
  onClick({ key, keyPath }) {
    const { logout, history, changeCurrentPosition, currentUser ,changeCurrentRole} = this.props;

    switch (key) {
      case "fullscreen":
        screenFull.toggle();
        return;
      case "settings":
        history.push("/settings");
        return;
      case "profile":
        history.push("/profile");
        return;
    }

    if (keyPath.contains("positions")) {
      let position = {};

      if (currentUser && currentUser.positions && currentUser.positions[0]) {
        position = currentUser.positions.find((item) => item.id === parseInt(key));
      }

      changeCurrentPosition(position);
    }

    if (keyPath.contains("roles")) {
      let role = {};

      if (currentUser && currentUser.roles && currentUser.roles[0]) {
        role = currentUser.roles.find((item) => item.id === parseInt(key));
      }

      if(role){
        changeCurrentRole({role_id: role.id}, ()=>{
          location.reload();
        });
      }
    }

    if (keyPath.contains("language")) {
      if (app.lang.set(key)) {
        location.reload();
      }
    } else if (keyPath.contains("account")) {
      if (key.equals("logout")) {
        logout();
      }
    }
  }

  /**
   *
   * @return {XML}
   * @static
   * @private
   */
  static get _languageMenu() {
    return (
      <Menu.SubMenu
        key="language"
        title={(() => {
          switch (app.lang.locale) {
            case "en":
              return "English";
            case "fa":
            default:
              return "فارسی";
          }
        })()}
      >
        <Menu.Item key="fa" className={app.lang.locale === "fa" && "jActive"} disabled={app.lang.locale === "fa"}>فارسی</Menu.Item>
        <Menu.Item key="en" className={app.lang.locale === "en" && "jActive"} disabled={app.lang.locale === "en"}>English</Menu.Item>
      </Menu.SubMenu>
    );
  }

  /**
   *
   * @return {XML}
   * @private
   */
  get _positionsMenu() {
    const { currentUser, currentPosition } = this.props;

    const items = [];

    if (currentUser && currentPosition && currentUser.positions && currentUser.positions.length > 1) {
      currentUser.positions.forEach((item) => {
        items.push(
          <Menu.Item
            key={`${item.id}`}
            className={item.id === currentPosition.id && "jActive"}
          >
            {item.name}
          </Menu.Item>
        );
      });

      return (
        <Menu.SubMenu
          key="positions"
          title={`${currentPosition.name}`}
        >
          {items}
        </Menu.SubMenu>
      );
    }

    return null;
  }

  /**
   *
   * @return {XML}
   * @private
   */
  get _roleMenu() {
    const { currentUser, currentRole } = this.props;

    const items = [];

    if (currentUser && currentRole && currentUser.roles && currentUser.roles.length > 1) {
      let _currentRole;
      currentUser.roles.forEach((item) => {
        items.push(
          <Menu.Item
            key={`${item.id}`}
            className={item.id === currentRole && "jActive"}
          >
            {item.name}
          </Menu.Item>
        );
        if(item.id === currentRole){
          _currentRole = item;
        }
      });

      return (
        <Menu.SubMenu
          key="roles"
          title={`${_currentRole.name}`}
        >
          {items}
        </Menu.SubMenu>
      );
    }

    return null;
  }

  /**
   *
   * @return {XML}
   * @private
   */
  get _accountMenu() {
    const currentUser = this.props.currentUser;

    return (
      <Menu.SubMenu
        key="account"
        title={
          <span
            style={{
              border: "2px solid rgba(255, 255, 255, .67)",
              borderRadius: "50%",
              marginTop: "6px",
              display: "grid",
            }}
          >
            <Avatar
              src={currentUser && currentUser.profile && currentUser.profile.avatar}
              text={currentUser && currentUser.profile ? `${currentUser.profile.firstName} ${currentUser.profile.lastName}` : currentUser.name}
            />
          </span>
        }
      >
        <Menu.Item
          key="profile">{currentUser.profile ? `${currentUser.profile.firstName} ${currentUser.profile.lastName}` : currentUser.name}</Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout">{app.translate("routes.auth.Logout")}</Menu.Item>
      </Menu.SubMenu>
    );
  }

  /**
   *
   * @return {XML}
   */
  render() {

    let state = Object.assign({}, {
      backgroundColor: {hex: '#404040'},
      organizationChart: 'chart',
    }, app.local.load('app'));

    return (
      <Layout.Header
        className="header nav"
        style={{
          background: state.backgroundColor.rgb ?
            `rgba(${state.backgroundColor.rgb.r},${state.backgroundColor.rgb.g},${state.backgroundColor.rgb.b},1)` :
            state.backgroundColor.hex,
        }}
      >
        <h2 className="logo">
          {app.translate("main.appName")}
        </h2>
        <Menu
          onClick={this.onClick}
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={["3"]}
          selectable={false}
          style={{
            borderBottom: 0,
            background: state.backgroundColor.rgb ?
              `rgba(${state.backgroundColor.rgb.r},${state.backgroundColor.rgb.g},${state.backgroundColor.rgb.b},1)` :
              state.backgroundColor.hex,
          }}
        >
          {this._positionsMenu}
          {this._roleMenu}
          {Nav._languageMenu}
          {/*<Menu.Item key="fullscreen">
            <MaterialIcon
              name={this.state.isFullScreen ? "fullscreen-exit" : "fullscreen"}
              size="small"
            />
          </Menu.Item>*/}
          <Menu.Item key="settings">
            <MaterialIcon
              name="settings"
              size="small"
            />
          </Menu.Item>
          {this._accountMenu}
          {/* <Hamburger*/}
          {/* color="white"*/}
          {/* onHamburgerToggle={onHamburgerToggle}*/}
          {/* className="hamburger-menu"*/}
          {/* />*/}
        </Menu>
      </Layout.Header>
    );
  }
}
